import type { MouseEvent, ReactNode } from 'react'
import { AnchoredPopover } from '@shared/ui'

interface LegacyAudioSettingsPopoverProps {
  readonly anchorEl: HTMLButtonElement | null
  readonly children: ReactNode
  readonly onClose: () => void
  readonly paperClassName: string
  readonly transitionDuration: number | undefined
  readonly disablePortal?: boolean
  readonly opensUp?: boolean
}

// Keep every legacy audio settings menu on the same click-away and focus lifecycle.
export function LegacyAudioSettingsPopover({
  anchorEl,
  children,
  onClose,
  paperClassName,
  transitionDuration,
  disablePortal = false,
  opensUp = false,
}: LegacyAudioSettingsPopoverProps) {
  return (
    <AnchoredPopover
      anchorEl={anchorEl}
      anchorOrigin={
        opensUp
          ? { horizontal: 'right', vertical: 'top' }
          : { horizontal: 'right', vertical: 'bottom' }
      }
      className={paperClassName}
      disablePortal={disablePortal}
      onClose={onClose}
      open={Boolean(anchorEl)}
      onClick={(event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
      }}
      transitionDuration={transitionDuration}
      transformOrigin={
        opensUp
          ? { horizontal: 'right', vertical: 'bottom' }
          : { horizontal: 'right', vertical: 'top' }
      }
    >
      {children}
    </AnchoredPopover>
  )
}
